import type { LogicalOperator, QueryFilterExpressionValue } from '@/entities/query/query-types';

export enum PREVIEW_BLOCK_ITEM_TYPE {
  AND = 'AND',
  OR = 'OR',
  NOT = 'NOT',
  EXPRESSION = 'expression',
  KEYWORD = 'keyword',
  USERNAME = 'username',
}

export type PreviewBlockItem = {
  type: PREVIEW_BLOCK_ITEM_TYPE;
  value: string;
};

export type LogicValidation = {
  isValid: boolean;
  warnings: string[];
  logicPreview: PreviewBlockItem[];
};

export type IncludeGroup = {
  id: string;
  op: LogicalOperator;
  values: QueryFilterExpressionValue[];
  currentInput: string;
  nextOp?: LogicalOperator;
};

export type ExcludeGroup = {
  values: QueryFilterExpressionValue[];
  currentInput: string;
};
